export default {
    setCarouselIndex(context, index) {
        context.commit("SET_CAROUSEL_INDEX", index);
    }
}
